import { getREProductsForCarousel } from 'aster-foundation/core/epharmacy/Product/redux/action';

const dynamicREAPICall = (dispatch, userAuth, requestParams) => {
  const { zoneData, userLogin, guestLogin } = userAuth;
  const { categoryId, productIds, offerType, onSuccess, onFailure, item } = requestParams;

  if (zoneData?.length > 0) {
    const params = {
      pageSize: '10',
      page: '0',
    };
    params.zone = zoneData?.join(',');
    if (productIds) {
      params.productIds = productIds;
    }
    if (offerType) {
      params.offerType = offerType;
    }
    if (categoryId) {
      params.categoryList = categoryId;
    }
    if (guestLogin || userLogin) {
      dispatch(
        getREProductsForCarousel({
          params,
          onSuccess: (response) => onSuccess(response, item),
          onFailure: (error) => onFailure(error, item),
        }),
      );
    }
  }
};
export default dynamicREAPICall;
